import * as tslib_1 from "tslib";
import { GetPnLUrl } from '../constants';
import _ from 'lodash';
import dayjs from 'dayjs';
const get = (api) => {
    return (request) => tslib_1.__awaiter(this, void 0, void 0, function* () {
        const apiResponse = yield api.get(GetPnLUrl, request);
        const sanitizedPnLItems = _.map(apiResponse.payload.Items, (item) => {
            const closeAmount = Number(item.CloseAmount);
            const closeOrderId = Number(item.CloseOrderId);
            const costBasis = Number(item.CostBasis);
            const dateClosed = dayjs(item.DateClosed).toDate();
            const dateOpened = dayjs(item.DateOpened).toDate();
            const openOrderId = Number(item.OpenOrderId);
            const quantity = Number(item.Quantity);
            return Object.assign({}, item, { CloseAmount: closeAmount, CloseOrderId: closeOrderId, CostBasis: costBasis, DateClosed: dateClosed, DateOpened: dateOpened, OpenOrderId: openOrderId, Quantity: quantity });
        });
        return Object.assign({}, apiResponse, { payload: apiResponse.payload
                ? Object.assign({}, apiResponse.payload, { Items: sanitizedPnLItems }) : undefined });
    });
};
export const pnlHistory = {
    get,
};
//# sourceMappingURL=getPnLItem.js.map